module.exports = __webpack_public_path__ + "static/steven-dohm-f110ec33e0d1af7fe75c8d5145d5d0f8.jpg";